import {inject, injectable} from 'inversify';

import type {BNUserFormsAnswersAnswerParams} from '../../../../../../api/types/bnrks/methods';
import type {BNBoundFormApiModel} from '../../../../../../api/types/bnrks/models';
import type {SendCromAnswersCommand} from '../SendCromAnswers.cmd';

import {apiRequest} from '../../../../../../api/utils/apiRequest';
import {expandObj} from '../../../../../../api/utils/expand';
import {CromMapperJrpc} from '../../../domain/Crom/mappers/jrpc/Crom.mapper.jrpc';

@injectable()
export class SendCromAnswersCommandJrpc implements SendCromAnswersCommand {
  constructor(
    @inject(CromMapperJrpc)
    private readonly cromMapper: CromMapperJrpc,
  ) {}

  async sendAnswers({
    answersByQuestionId,
    cromId,
  }: SendCromAnswersCommand.Params): SendCromAnswersCommand.Response {
    const {
      _expanded,
      bound_form,
    }: {_expanded: Record<string, any>; bound_form: BNBoundFormApiModel} =
      await apiRequest<BNUserFormsAnswersAnswerParams>({
        method: 'user.forms.answers.answer',
        params: {
          _id: cromId,
          answers: this.mapAnswersToRequestParams(answersByQuestionId),
          expand: this.cromMapper.expand.getByEnv(),
        },
      });

    const expandedForm: CromMapperJrpc.ExpandedApiData = expandObj(bound_form, {
      expand: this.cromMapper.expand.getByEnv(),
      expanded: _expanded,
    });

    return this.cromMapper.mapDataToModel(expandedForm);
  }

  private mapAnswersToRequestParams(
    answers: SendCromAnswersCommand.Params['answersByQuestionId'],
  ): BNUserFormsAnswersAnswerParams['answers'] {
    return Array.from(answers.values()).reduce(
      (acc, answer) => ({
        ...acc,
        [answer.question.id]: answer.value,
      }),
      {},
    );
  }
}
